import { useCallback, useRef } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

const MODULE_VIEW_EVENT_NAME = 'petition_manage_ready_to_share_module_view';

type UseViewTrackingParams = {
	selectedTab: string;
};

type UseViewTrackingResult = {
	trackView: (currentPosition: string) => void;
};

export function useViewTracking({ selectedTab }: UseViewTrackingParams): UseViewTrackingResult {
	const track = useTracking();
	const isModuleViewTrackedRef = useRef(false);

	// Track module view event - deferred to ensure page view event fires first
	const trackView = useCallback(
		(currentPosition: string) => {
			if (isModuleViewTrackedRef.current || currentPosition === 'below') {
				return;
			}

			// Defer to ensure page view event fires first (from useLayoutEffect in Layout)
			requestAnimationFrame(() => {
				void track(MODULE_VIEW_EVENT_NAME, {
					context: 'petition_dashboard_ready_to_share_post',
					view_context: selectedTab,
				});
			});
			isModuleViewTrackedRef.current = true;
		},
		[track, selectedTab],
	);

	return {
		trackView,
	};
}
